// @ts-strict-ignore
import { Middleware } from 'redux'
import { createLogger } from 'redux-logger'

const __DEV__ = import.meta.env.MODE === 'development'

export const loggerMiddleware: Middleware = createLogger({
	predicate: () => __DEV__,
})

/**
 * Which environment Sentry files events under. Sentry only recognises production and staging; every
 * other Rails env collapses to 'development', which is the value `main.tsx` treats as "do not
 * initialise Sentry at all".
 */
export function sentryEnvironment() {
	switch (ENV.ENVIRONMENT) {
		case 'production':
			return 'production' as const
		case 'staging':
			return 'staging' as const
		default:
			return 'development' as const
	}
}
